import { types as t } from 'mobx-state-tree';
import { PERMISSIONS } from '../types';

const KNOWN: string[] = Object.values(PERMISSIONS);

// The API can grant a permission this build doesn't know yet (a new one ships there first): drop
// it rather than fail to load the organization.
const OrganizationsPermissionsModel = t.snapshotProcessor(t.array(t.enumeration('OrganizationPermissions', Object.values(PERMISSIONS))), {
  preProcessor: (snapshot: string[]) => snapshot.filter((permission) => KNOWN.includes(permission)) as PERMISSIONS[]
});

export default OrganizationsPermissionsModel;
